import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ContentCard.scss'; // The SASS file containing styles for this component

const ContentCard = () => {
  const navigate = useNavigate();

  const handleNavigationClick = () => {
    navigate('/Center'); // Replace with the target path
  };

  return (
    <div className="content-card">
      <div className="content-list">
        {/* Replace with actual list items */}
        <p>1. List item one...</p>
        <p>2. List item two...</p>
        <p>3. List item three...</p>
        {/* Add additional list items as needed */}
      </div>
      <div className="radio-button-group">
        <input type="radio" id="option" name="option" value="option" />
        <label htmlFor="option">I have read and accepted the above</label>
      </div>
      <div className="button-group">
        <button className="button-outline">Cancel</button>
        <button className="button-primary" onClick={handleNavigationClick}>Confirm order</button>
      </div>
    </div>
  );
};

export default ContentCard;
